<template>
  <div>
    <div style="background-color: #FFFFFF">
      <flexbox class="p-2" orient="vertical">
        <flexbox-item v-for="cartItem in list">
          <CartItem :title="cartItem.nameHk" :currency="orderCurrency" :price="getRoundPrice(cartItem.unitPrice)" :image="cartItem.imageMain" :quantity="cartItem.quantity" :products="cartItem" :orderStatus="paymentStatus"></CartItem>
        </flexbox-item>
        <flexbox-item v-if="currentModule == 'Account'" class="text-right">
          <cell class="orderItemCell" :title="$t('cart.order.tariff')"><span class="orderItemText">{{orderCurrency}} {{getRoundPrice(tariff)}}</span></cell>
          <cell class="orderItemCell" :title="$t('cart.order.shippingFee')"><span class="orderItemText">{{orderCurrency}} {{getRoundPrice(shippingFee)}}</span></cell>
          <cell class="orderItemCell" :title="$t('cart.order.discount')"><span class="orderItemText" style="color: red">{{orderCurrency}} - {{getRoundPrice(discount)}}</span></cell>
        </flexbox-item>
        <flexbox-item class="text-right px-2">
          {{$t('cart.total')}} {{totalQuantity}} {{$t('cart.products')}}
          {{$t('cart.totalPrice')}}: <b>{{orderCurrency}} <b v-if="actualAmount">{{actualAmount}}</b> <b v-else>{{totalPrice}}</b> </b>
        </flexbox-item>
      </flexbox>
    </div>
  </div>
</template>
<script type="text/javascript">
import { mapGetters } from 'vuex'
import CartItem from './CartItem'
import { Cell, Group, Flexbox, FlexboxItem } from 'vux'

export default {
  name: 'OrderItemList',
  components: {
    CartItem,
    Cell,
    Group,
    Flexbox,
    FlexboxItem,
  },
  props: {
    list: Array,
    currency: String,
    actualAmount: {
      type: String,
      default:'',
    },
    tariff: {
      type: String,
      default:'',
    },
    shippingFee: {
      type: String,
      default:'',
    },
    discount: {
      type: String,
      default:'',
    },
    orderStatus:String
  },
  data() {
    return {
      orderTotalAmount: '',
      orderCurrency: '',
      paymentStatus:this.orderStatus
    }
  },
  created() {
    if(!isNaN(this.actualAmount)){
      this.orderTotalAmount = this.actualAmount
    }else if(this.totalPrice){
      this.orderTotalAmount = this.getRoundPrice(this.totalPrice);
    }
    if (this.currency) {
      this.orderCurrency = this.currency
    } else {
      this.orderCurrency = this.$t('kol.priceUnit');
    }

  },
  mounted() {},
  watch: {
    totalPrice: {
      handler() {
        this.orderTotalAmount = this.getRoundPrice(this.totalPrice);
      }
    }
  },
  computed: {
    ...mapGetters([
      'getExchangePrice',
      'getPriceByCurrency',
      'getRoundPrice',
    ]),
    currentModule(){
      return this.$store.state.routeStatus.module;
    },

    // totalPriceProduct() {
    //   var totalPrice = 0;
    //   for (var i = this.list.length - 1; i >= 0; i--) {
    //     totalPrice += this.list[i]['unitPrice'] * this.list[i]['quantity'];
    //   }
    //   return totalPrice;
    //   return this.totalPrice
    // },
    totalQuantity() {
      return this.list.length;
    },
    totalPrice(){
      return this.$store.getters.totalPrice;
    }
  },
  methods: {

  },
}

</script>
<style type="text/css">
.orderItemCell .weui-cell__ft{
  width: 100px !important;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/Cart/components/OrderItemList.vue